// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-27T06:56:37Z                      #

// ##############################################################


/**
 * 
 */
enum Type {
    WAITING = 'WAITING', 
    SIGNED = 'SIGNED', 
    APPROVED = 'APPROVED', 
    REJECTED = 'REJECTED', 
    ALL = 'ALL'
};
export default Type;

